import React from 'react';
import { Button } from '@brighterion/br-ui';
import { useTranslation, Trans } from 'react-i18next';
import { handleKeyEvent, handleOnClickEvent } from 'Utils';
import styles from './LoadMoreButton.css';

type Props = {
    dataTestId?: string;
    disabled: boolean;
    onClick: () => void;
    currentCount?: number;
    totalCount?: number;
};

const LoadMoreButton = ({ dataTestId, disabled, onClick, currentCount, totalCount }: Props) => {
    const { t } = useTranslation();

    return (
        <div className={styles.loadMoreContainer}>
            {currentCount && totalCount && (
                <div className={styles.textInfo}>
                    <Trans i18nKey='loadMoreCount'>
                        Viewing <strong>{{ currentCount }}</strong> of <strong>{{ totalCount }}</strong>
                    </Trans>
                </div>
            )}
            <Button
                dataTestId={dataTestId || 'load-more'}
                disabled={disabled}
                variant='contextual-secondary'
                onClick={handleOnClickEvent(onClick)}
                onKeyDown={handleKeyEvent(onClick)}
            >
                {t('Load More')}
            </Button>
        </div>
    );
};

export default React.memo(LoadMoreButton);
